import React from 'react';
import Basepage, { BasePageState } from '../Basepage';

import imgCookie from './images/screenshot_cookies.jpg';
import imgBod from './images/screenshot_bod.jpg';
import imgArtikel from './images/screenshot_artikelansicht.jpg';
import imgKauf from './images/screenshot_kaufabschliessen.jpg';

import './index.scss';

interface HowToStartState extends BasePageState {}
interface HowToStartModel {}

export default class HowToStartPage extends Basepage<
  HowToStartState,
  HowToStartModel
> {
  renderChild(): JSX.Element {
    return (
      <div id="HowToStart">
        <b>
          Vielen Dank für Ihr Interesse an einer Zusammenarbeit mit Buchbutler!
        </b>
        <br />
        <br />
        Wir freuen uns sehr über Ihr Vertrauen und heißen Sie herzlich
        willkommen! Damit Ihr erster Einkauf bei uns reibungslos abläuft, haben
        wir Ihnen im Folgenden eine Schritt-für-Schritt-Anleitung
        zusammengestellt:
        <br />
        <br />
        <hr />
        <b>So funktioniert Ihr erster Einkauf bei Buchbutler.de</b>
        <ol>
          <li>
            <b>Website aufrufen & Cookies für Buchhändler akzeptieren</b>
            <br />
            Besuchen Sie unsere Website unter <b>www.buchbutler.de</b>. Unten
            auf der Seite erscheint ein Cookie-Banner. Bitte{' '}
            <b>akzeptieren Sie die Cookies für Buchhändler</b>, um die korrekte
            Shop-Ansicht zu erhalten.
            <br />
            <br />
            <img src={imgCookie} />
            <br />
            <br /> Sie erkennen dies daran, dass über dem Suchfeld{' '}
            <b>„Barsortiment on demand für Buchhändler“</b> angezeigt wird.
            <br />
            <br />
            <img src={imgBod} />
            <br />
            <br />
            <i>
              Sollten Sie versehentlich die Cookies für Privatkunden akzeptiert
              haben, gelangen Sie in unseren Endkundenshop. In diesem Fall rufen
              Sie bitte erneut www.buchbutler.de auf und wählen diesmal die
              Cookies für Buchhändler.
            </i>
          </li>
          <li>
            <b>Artikel suchen</b>
            <br />
            Verwenden Sie das <b>Suchfeld</b>, um gezielt nach Titeln, Autoren
            oder ISBNs zu suchen. Natürlich können Sie auch durch unser
            Sortiment stöbern.
          </li>
          <li>
            <b>Produktinformationen prüfen</b>
            <br />
            Zu jedem Artikel sehen Sie direkt:
            <ul>
              <li>
                Ihren <b>Nettoeinkaufspreis</b>
              </li>
              <li>
                den <b>individuellen Rabatt</b>
              </li>
              <li>
                die <b>voraussichtliche Lieferzeit</b>
                <br /> Wenn Artikel über mehrere Lieferanten verfügbar sind,
                können Sie zwischen den Bezugsvarianten{' '}
                <b>„schnellstmöglichst“</b>
                oder <b>„günstigst“</b> wählen – je nachdem, ob Ihnen Lieferzeit
                oder Preis wichtiger ist. <br />
                <br />
                <img src={imgArtikel} />
                <br />
                <br />
              </li>
            </ul>{' '}
          </li>
          <li>
            <b>Warenkorb füllen & zur Kasse gehen</b> Legen Sie die gewünschten
            Artikel in den <b>Warenkorb</b>. <br />
            Sobald Sie Ihre Auswahl abgeschlossen haben, klicken Sie bitte auf
            den Button <b>„Zur Kasse“</b>.
          </li>
          <li>
            <b>Registrierungsprozess durchlaufen</b>
            <br />
            Sie werden nun aufgefordert eine E-Mail-Adresse einzugeben und
            werden dann Schritt für Schritt durch den{' '}
            <b>Registrierungsprozess</b> geführt. <br />
            <i>
              Sollten Sie keine Verkehrsnummer besitzen, melden Sie sich bitte
              telefonisch bei unserem Kundenservice unter{' '}
              <b>02571 / 8 07 28 80</b> – wir helfen Ihnen gern weiter.
            </i>
          </li>
          <li>
            <b>Zahlart wählen</b>
            <br /> Nach dem Ausfüllen aller erforderlichen Felder wählen Sie
            bitte Ihre bevorzugte <b>Zahlart</b> aus. Wir bieten Ihnen die
            Abrechnung <b>per Rechnung</b> oder <b>über die BAG</b> an.{' '}
          </li>
          <li>
            <b>Kauf abschließen</b>
            <br />
            Nachdem Sie die Zahlart ausgewählt haben, schließen Sie Ihre
            Bestellung ab, indem Sie auf den Button <b>
              „Kauf abschließen“
            </b>{' '}
            klicken.
            <br />
            <br /> <img src={imgKauf} />
            <br />
            <br />{' '}
          </li>
          <li>
            <b>Bestätigung per E-Mail erhalten</b>
            <br /> Nach Abschluss Ihrer Bestellung erhalten Sie zwei E-Mails:
            <ul>
              <li>
                eine separate E-Mail mit einem <b>Bestätigungslink</b> zur
                Verifizierung Ihrer E-Mail-Adresse und zur{' '}
                <b>Vergabe eines Passworts</b> für Ihr persönliches Kundenkonto
              </li>
              <li>eine Auftragsbestätigung </li>
            </ul>
            <br />
            <i>
              Bitte beachten Sie, dass es <b>ca. 15 Minuten</b> dauern kann, bis
              Sie die Mails erhalten.
            </i>
          </li>
          <li>
            <b>Zukünftige Bestellungen</b>
            <br />
            Beim nächsten Besuch auf unserer Website loggen Sie sich bitte vor
            dem Einkauf mit Ihrer <b>E-Mail-Adresse und Ihrem Passwort</b> in
            Ihr Kundenkonto ein. So können Sie direkt bestellen, Ihre bisherigen
            Aufträge einsehen und Ihre Daten verwalten.{' '}
          </li>
        </ol>
        <hr />
        Wenn Sie Fragen haben oder Hilfe bei der Registrierung benötigen, steht
        Ihnen unser Kundenservice jederzeit gerne zur Verfügung. <br />
        <br />
        Wir freuen uns auf eine erfolgreiche Zusammenarbeit mit Ihnen!
        <br />
        <br /> Mit freundlichen Grüßen <br />
        <b>Ihr Team von BuchButler</b>
      </div>
    );
  }
  initState(base: BasePageState): HowToStartState {
    let newState: HowToStartState = {
      ...base,
    };

    return newState;
  }
  getApiReqestUrl(checkOnly: boolean): string {
    return this.state.apiBase + '/Standard.php';
  }

  releaseOneCommand(): void {}
  childDidMount(): void {}
  childDidUnmount(): void {}
  initJSChild(): string {
    return '';
  }
  childDidUpdate(prevProp: any, prevState: any): void {}
  getRightBreadCrumbParts(): JSX.Element {
    return <></>;
  }

  pageHeaderGetter(): string | null {
    return null;
  }
  pageTitleGetter(): string {
    return 'HowToStart';
  }
  getBreadCrumb(): JSX.Element {
    return <span>Seite Buchbutler - wie gehts los?</span>;
  }
  getType(): string {
    return 'HowToStartPage';
  }
}
